import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';

export default function Layout2({ darkMode: initialDarkMode }) {
  const [darkMode, setDarkMode] = useState(() => {
    // Initialize from localStorage or use prop
    const savedMode = localStorage.getItem('darkMode');
    return savedMode !== null ? savedMode === 'true' : initialDarkMode;
  });

  useEffect(() => {
    // Save to localStorage whenever it changes
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const handleDarkModeToggle = () => {
    setDarkMode(prev => !prev);
  };
  return (
    <div className={`${darkMode ? 'cs_dark' : ''}`}>
      <Header
        logoUrl={darkMode ? '/images/logo_white.svg' : '/images/logo.svg'}
        actionBtnText="Get A Quote"
        actionBtnUrl="/contact"
        darkMode={darkMode}
        onDarkModeToggle={handleDarkModeToggle}
      />
      <Outlet />
      <Footer />
    </div>
  );
}
